import { createShopItem } from "@/js/ComponentJs/shopItemContainer.js";
import "@/css/Shop/operate.css";
import { get } from "@/js/request.js";

const getWindowSetZoom = function () {
  return window.innerWidth < 500
    ? 3
    : window.innerWidth < 600
    ? 3.5
    : window.innerWidth < 740
    ? 3.6
    : window.innerWidth < 800
    ? 3.7
    : window.innerWidth < 900
    ? 3.8
    : window.innerWidth < 1000
    ? 3.9
    : window.innerWidth < 1100
    ? 4
    : window.innerWidth < 1200
    ? 4.1
    : window.innerWidth < 1300
    ? 4.2
    : window.innerWidth < 1400
    ? 4.3
    : window.innerWidth < 1500
    ? 4.4
    : window.innerWidth < 1600
    ? 4.5
    : window.innerWidth < 1700
    ? 4.6
    : 5;
};
let map = null;
let markers = [];
let curIcon = null;
let oldIcon = null;
let shopList = [];
let hasMap = false;
let infoWindow = null;
let zoom = getWindowSetZoom();
// 地图
AMapLoader.load({
  key: "238fcb8de1acf2f65493c9c165c7c1b7", // 申请好的Web端开发者Key，首次调用 load 时必填
  version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
})
  .then((AMap) => {
    //大标记点
    curIcon = new AMap.Icon({
      size: new AMap.Size(34, 37),
      image:
        "https://obs.shaobohealth.cn/minipro/scshop/operate-map/images/operate-location.png",
      imageSize: new AMap.Size(46, 45),
    });
    //小标记点
    oldIcon = new AMap.Icon({
      size: new AMap.Size(34, 37),
      // 图标的取图地址
      image:
        "https://obs.shaobohealth.cn/minipro/scshop/operate-map/images/operate-location.png",
      // 图标所用图片大小
      imageSize: new AMap.Size(28, 31),
    });
    //信息窗体
    infoWindow = new AMap.InfoWindow({
      content: "",
    });
    map = new AMap.Map("map", {
      zoom, //设置地图显示的缩放级别
      center: [108.5525, 34.3227], //设置地图中心点坐标
      viewMode: "2D", //设置地图模式
    });

    window.addEventListener("resize", function () {
      map.setZoom(getWindowSetZoom());
    });

    hasMap = true;
  })
  .catch((e) => {
    console.error(e); //加载错误提示
  });
let currentId = "";
//标记点点击事件
const onMarkerClick = function (e) {
  //存在已点击标记点，标记点恢复原有大小
  if (currentId) {
    let oldMarker = markers.filter((item) => item.id == currentId)[0];
    oldMarker.setIcon(oldIcon);
  }
  console.log(e);
  currentId = e.target.id;
  infoWindow.setContent("<div>" + e.target.name + "</div>");
  infoWindow.open(map, e.target.getPosition());
  //修改标记点大小
  e.target.setIcon(curIcon);
};
//关闭信息窗体
function closeInfoWindow() {
  map.clearInfoWindow();
}

//请求接口
function addItem(successCallBack) {
  get("/shop/operate-list", {}, successCallBack);
}
//初次请求
addItem((res) => {
  let newData = res.data;
  let time = setInterval(() => {
    if (hasMap) {
      // 创建一个 Marker 实例：
      newData.forEach(function (marker1) {
        var marker = new AMap.Marker({
          map: map,
          icon: oldIcon,
          position: [marker1.lng, marker1.lat],
        });
        marker.name = marker1.name;
        marker.id = marker1.id;
        markers.push(marker);
        marker.on("click", onMarkerClick); //添加点击事件
      });
      shopList.push(...newData);
      clearInterval(time);
    }
  }, 1000);
});

document.getElementById("loading").classList.remove("active");
